// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********   Button Ui Css   *****/
.simple-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  /* background: #00A19B; */
  background: #bae9e9;
  min-height: 40px;
  font-size: 16px;
  font-weight: 500;
  height: 62px;
  /* color: #FFFFFF; */
  color: #000000;
  cursor: pointer;
  border: none;
  /* margin-top: 20px; */
  border-radius: 9px;
  outline: none;
}

.simple-button:hover {
  background: #00a19b;
  color: #ffffff;
}

button.simple-button[disabled]:hover {
  cursor: no-drop;
  background: #bae9e9;
  color: #000000;
}

.simple-button.gray-btn {
  background: #f3f3f3;
  color: #1a1919;
  outline: none;
}

.login-with-google-btn-wrap button img {
  width: 28px;
}

.button-loading-gif {
  width: 150px;
}

button.simple-button[disabled] {
  cursor: no-drop;
  opacity: 0.7;
}

/********   Round Button Ui Css   *****/
.round-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 154px;
  height: 49px;
  background: #00a19b;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  cursor: pointer;
  border: none;
  border-radius: 25px;
  outline: none;
}

.book-button-wrapper button {
  height: 49px;
}

.pay-button-wrapper {
  margin-top: 10px;
}

.pay-button-wrapper button {
  height: 49px;
}

/****** Cancel Order button *****/

button.cancel-order-button {
  border: 1px solid #00a19bf7;
  border-radius: 9px;
  /* background-color: transparent; */
  background-color: #f3f3f3;
  color: #00a19b;
  height: 49px;
  width: 405px;
  outline: none;
}

button.add-to-cart-btn {
  border: 1px solid #00a19bf7;
  border-radius: 9px;
  background-color: #f3f3f3;
  color: #00a19b;
  height: 49px;
  font-size: 14px;
}

/********   Input field Ui Css   *****/
.change-input-wrap {
  position: absolute;
  top: 22px;
  right: 20px;
  z-index: 99;
}

.change-input-wrap h3 {
  font-size: 14px;
  color: #00a19b;
  font-weight: 600;
  margin: 0px;
  cursor: pointer;
}

input.active-profile-input {
  border: 1px solid #00a19b !important;
}

.login-option input {
  width: 100%;
  height: 62px;
  /* margin: 0 auto; */
  border: 1px solid rgb(255 255 255 / 20%);
  border-radius: 9px;
  margin-bottom: 20px;
  cursor: pointer;
  padding: 10px 0px;
  padding-left: 20px;
  background-color: transparent;
  outline: none;
  color: #fff;
}

.login-wrapper .label-before,
.field input:focus + label::before,
.field input:valid + label::before,
.field input.active + label::before {
  color: #626262;
  line-height: 20px;
  font-size: 12px;
  top: -10px;
  background: #fff;
  padding: 0 6px;
  left: 9px;
  font-weight: 400;
  z-index: 91;
}

.login-wrapper .label-before,
.ant-form-item textarea:focus + label::before,
.ant-form-item textarea:valid + label::before {
  color: #fff;
  line-height: 20px;
  font-size: 16px;
  top: -10px;
  background: #082026;
  padding: 0 6px;
  left: 9px;
  font-weight: 200;
}

.field {
  position: relative;
  width: 100%;
  margin-bottom: 20px;
}

.field label::before {
  content: attr(title);
  position: absolute;
  top: 20px;
  left: 15px;
  line-height: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #626262;
  transition: 300ms all;
  opacity: 0.5;
}

.field input,
.field textarea {
  line-height: 40px;
  padding: 0 15px;
  box-sizing: border-box;
  font-size: 14px;
  color: #1a1919;
  border: 1px solid #f3f3f3;
  border-radius: 9px;
  margin: 0px;
  font-weight: 500;
  z-index: 22;
  position: relative;
}

.field input:focus,
.field textarea:focus {
  outline: 0;
}
.field input:valid + label::before,
.field textarea:valid + label::before {
  content: attr(data-title);
}

.field label.top:before {
  top: -12px;
  background: #fff !important;
  font-size: 16px;
  color: #5e5e5e;
}

.field img {
  position: absolute;
  top: 14px;
  right: 12px;
  width: 34px;
  z-index: 111;
  cursor: pointer;
}

/* input#email:autofill~label {
  top: -9px !important;
  font-weight: 500;
  font-size: 12px;
  line-height: 17px;
  color: var(--gray-700);
  background: var(--gray-50);
  padding: 0 8px;
  z-index: 1;
} */

.profile-input-field {
  margin-bottom: 34px;
}

/* Chrome, Safari, Edge, Opera */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.field input:disabled {
  opacity: 0.5;
}

/********** Range slider css ****/

/* .chart-wrap {
  display: flex;
  justify-content: center;
} */

.range-container {
  display: flex;
  align-items: center;
  padding: 10px;
  height: 62px;
  border: 1px solid #f3f3f3;
  border-radius: 9px;
  position: relative;
  padding-top: 32px;
}

.range-container.dusting-slider {
  padding-top: 10px;
}

input[type="range"] {
  width: 400px;
}

.main-box {
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

#steps {
  margin-top: 50px;
}

.steps-counts {
  display: flex;
  justify-content: space-between;
  width: 26%;
}

#stepsall {
  border-radius: 8px;
  height: 12px;
  outline: none;
  -webkit-appearance: none;
  cursor: pointer;
  /* width: 100%; */
  width: 336px;
}

input[type="range"]::-webkit-slider-thumb {
  width: 18px;
  height: 18px;
  -webkit-appearance: none;
  background: #ffffff;
  box-shadow: 0px 0px 4px #00000029;
  border-radius: 50%;
  padding: 0px;
  margin: 0px;
}

.chart-and-image-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-right: 10px;
  padding-left: 10px;
  width: 100px;
  /* margin-right: 26px; */
}

.chart-and-image-left-wrap{
  margin-right: 26px;
}

.sq-chart-and-img-wrap{
  margin-right: 26px;
}

.chart-and-image-wrap img {
  width: 33px;
  margin-top: -24px;
}

.range-container.dusting-slider .chart-and-image-wrap img {
  width: 34px;
  margin-top: 0px;
}

p#output {
  width: 40px;
  font-size: 14px;
  color: #00a19b;
  font-weight: 600;
  margin: 0px;
  text-align: left;
  display: flex;
  gap: 4px;
}

p#output-reverse {
  width: 40px;
  font-size: 14px;
  color: #1a1919;
  font-weight: 600;
  margin: 0px;
  text-align: right;
}

.cleaning-name-wrap {
  position: absolute;
  top: 6px;
  left: 60px;
}

.cleaning-name-wrap p,
.cleaning-reverse-name-wrap p {
  font-size: 14px;
  color: #626262;
  font-weight: 400;
  margin: 0px;
}

.cleaning-reverse-name-wrap {
  position: absolute;
  top: 6px;
  right: 60px;
}

.flooring-slider-wrap h5.flooring-text {
  font-size: 14px;
  color: #1a1919;
  font-weight: 600;
  margin: 0px;
  padding-bottom: 5px;
  padding-left: 10px;
}

.dusting-slider-wrap {
  margin-top: 14px;
}

.dusting-slider-wrap h5.dusting-text {
  font-size: 14px;
  color: #1a1919;
  font-weight: 600;
  margin: 0px;
  padding-bottom: 5px;
  padding-left: 10px;
}

input.error-msg {
  border: 1px solid #ff0000 !important;
}

.error-msg.field label::before {
  color: #ff0000 !important;
  opacity: 1;
}

label.error-msg {
  color: #ff0000 !important;
}

.disabled-button {
  background: #f3f3f3;
  opacity: 0.8;
}

.disabled-button:hover {
  background: #f3f3f3;
  opacity: 0.8;
  color: #000000;
}

.date-and-time-wrapper input.error-msg::placeholder {
  color: #ff0000 !important;
}

.error-msg.field label::before {
  color: #ff0000 !important;
  opacity: 1;
}

.extra-addto-cart-btn .disabled-button {
  height: 49px;
  opacity: 0.8;
}

input.squirefeet-input {
  text-align: right;
  padding-right: 40px !important;
}

.squrefeet-slider-wrap{
  margin-bottom: 16px;
}

.password-icon img:hover{
  scale: 0.9;
}



/******* Resposive css ****/
@media (max-width: 1024px) {
  .simple-button {
    height: 62px;
    border-radius: 9px;
    font-size: 14px;
  }

  .simple-button.gray-btn {
    height: 62px;
  }

  .dusting-slider-wrap {
    margin-top: 20px;
  }

  .sq-chart-and-img-wrap {
    margin-right: 26px;
  }

  .chart-and-image-left-wrap {
    margin-right: 26px;
}

.chart-and-image-left-wrap img{
  display: none;
}

.chart-and-image-wrap {
  width: unset;
}

#stepsall {
  min-width: 280px;
}

}

@media (max-width: 500px) {
  #stepsall {
    min-width: unset;
    width: 280px;
  }
}

@media (max-width: 360px) {
  #stepsall {
    width: 200px;
  }
}
/* 
@media (min-width: 768px) and (max-width: 1024px) {
  .field {
    margin-bottom: 18px;
 }

 .login-option input {
  height: 58px;
  font-size: 14px;
 }

.field input, .field textarea {
  font-size: 14px;
 }

 .field label::before {
   top: 18px;
 }

.simple-button {
  height: 58px;
  font-size: 15px;
 }
} */

@media (min-width: 1025px) and (max-width: 1199px) {
  .field {
    margin-bottom: 18px;
  }

  .login-option input {
    height: 58px;
    font-size: 14px;
  }

  .field input,
  .field textarea {
    font-size: 14px;
  }

  .field label::before {
    top: 18px;
  }

  .simple-button {
    height: 58px;
    font-size: 15px;
  }

  .field {
    margin-bottom: 18px;
  }

  .login-option input {
    /* height: 58px; */
    height: 48px;
    font-size: 12px;
  }

  .field input,
  .field textarea {
    font-size: 12px;
  }

  /* .field label::before {
 top: 18px;
} */

  .field label::before {
    top: 14px;
    font-size: 12px;
  }

  .simple-button {
    height: 58px;
    font-size: 15px;
  }

  .range-container {
    height: 48px;
  }

  #stepsall {
    height: 10px;
  }

  input[type="range"]::-webkit-slider-thumb {
    width: 14px;
    height: 14px;
  }

  p#output {
    font-size: 12px;
  }

  p#output-reverse {
    font-size: 12px;
  }

  .chart-and-image-left-wrap {
    margin-right: 0px;
  }
}

@media (min-width: 1025px) and (max-width: 1599px) {
  .field {
    margin-bottom: 18px;
  }

  .login-option input {
    /* height: 58px; */
    height: 48px;
    font-size: 12px;
  }

  .field input,
  .field textarea {
    font-size: 12px;
  }

  /* .field label::before {
     top: 18px;
   } */

  .field label::before {
    top: 14px;
    font-size: 12px;
  }

  .simple-button {
    /* height: 58px; */
    height: 48px;
    font-size: 14px;
  }

  .range-container {
    height: 48px;
  }

  #stepsall {
    height: 10px;
  }

  input[type="range"]::-webkit-slider-thumb {
    width: 14px;
    height: 14px;
  }

  p#output {
    font-size: 12px;
  }

  p#output-reverse {
    font-size: 12px;
  }

  .field img {
    position: absolute;
    top: 10px;
    width: 28px;
  }

  .login-with-google-btn-wrap button img {
    width: 24px;
  }

  .PhoneInputCountry {
    font-size: 14px;
  }

  .PhoneInputCountry img {
    width: 26px !important;
  }

  .field.phone-number-input input::placeholder {
    font-size: 12px !important;
    font-weight: 500;
    color: #626262;
    opacity: 0.5;
  }

  .squrefeet-slider-wrap{
    margin-bottom: 6px;
  }

  #stepsall {
    width: 220px;
  }
}

@media (min-width: 1600px) and (max-width: 1700px) {
    #stepsall {
      width: 286px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/UIComponents/style.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA,iCAAiC;;AAEjC;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,mCAAmC;EACnC,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,WAAW;AACb;;AAEA;;;;EAIE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,YAAY;AACd;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;AACZ;AACA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;;;;;;;;;GASG;;AAEH;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA,iCAAiC;;AAEjC;;;GAGG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;;;AAIA,2BAA2B;AAC3B;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;AAEA;EACE;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;AACA;;;;;;;;;;;;;;;;;;;;;;;GAuBG;;AAEH;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;GAEC;;EAED;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;MAEI;;EAEJ;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;IACd,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;IACI;MACE,YAAY;EAChB;AACF","sourcesContent":["/********   Button Ui Css   *****/\n.simple-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: 100%;\n  /* background: #00A19B; */\n  background: #bae9e9;\n  min-height: 40px;\n  font-size: 16px;\n  font-weight: 500;\n  height: 62px;\n  /* color: #FFFFFF; */\n  color: #000000;\n  cursor: pointer;\n  border: none;\n  /* margin-top: 20px; */\n  border-radius: 9px;\n  outline: none;\n}\n\n.simple-button:hover {\n  background: #00a19b;\n  color: #ffffff;\n}\n\nbutton.simple-button[disabled]:hover {\n  cursor: no-drop;\n  background: #bae9e9;\n  color: #000000;\n}\n\n.simple-button.gray-btn {\n  background: #f3f3f3;\n  color: #1a1919;\n  outline: none;\n}\n\n.login-with-google-btn-wrap button img {\n  width: 28px;\n}\n\n.button-loading-gif {\n  width: 150px;\n}\n\nbutton.simple-button[disabled] {\n  cursor: no-drop;\n  opacity: 0.7;\n}\n\n/********   Round Button Ui Css   *****/\n.round-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: 154px;\n  height: 49px;\n  background: #00a19b;\n  font-size: 14px;\n  font-weight: 500;\n  color: #ffffff;\n  cursor: pointer;\n  border: none;\n  border-radius: 25px;\n  outline: none;\n}\n\n.book-button-wrapper button {\n  height: 49px;\n}\n\n.pay-button-wrapper {\n  margin-top: 10px;\n}\n\n.pay-button-wrapper button {\n  height: 49px;\n}\n\n/****** Cancel Order button *****/\n\nbutton.cancel-order-button {\n  border: 1px solid #00a19bf7;\n  border-radius: 9px;\n  /* background-color: transparent; */\n  background-color: #f3f3f3;\n  color: #00a19b;\n  height: 49px;\n  width: 405px;\n  outline: none;\n}\n\nbutton.add-to-cart-btn {\n  border: 1px solid #00a19bf7;\n  border-radius: 9px;\n  background-color: #f3f3f3;\n  color: #00a19b;\n  height: 49px;\n  font-size: 14px;\n}\n\n/********   Input field Ui Css   *****/\n.change-input-wrap {\n  position: absolute;\n  top: 22px;\n  right: 20px;\n  z-index: 99;\n}\n\n.change-input-wrap h3 {\n  font-size: 14px;\n  color: #00a19b;\n  font-weight: 600;\n  margin: 0px;\n  cursor: pointer;\n}\n\ninput.active-profile-input {\n  border: 1px solid #00a19b !important;\n}\n\n.login-option input {\n  width: 100%;\n  height: 62px;\n  /* margin: 0 auto; */\n  border: 1px solid rgb(255 255 255 / 20%);\n  border-radius: 9px;\n  margin-bottom: 20px;\n  cursor: pointer;\n  padding: 10px 0px;\n  padding-left: 20px;\n  background-color: transparent;\n  outline: none;\n  color: #fff;\n}\n\n.login-wrapper .label-before,\n.field input:focus + label::before,\n.field input:valid + label::before,\n.field input.active + label::before {\n  color: #626262;\n  line-height: 20px;\n  font-size: 12px;\n  top: -10px;\n  background: #fff;\n  padding: 0 6px;\n  left: 9px;\n  font-weight: 400;\n  z-index: 91;\n}\n\n.login-wrapper .label-before,\n.ant-form-item textarea:focus + label::before,\n.ant-form-item textarea:valid + label::before {\n  color: #fff;\n  line-height: 20px;\n  font-size: 16px;\n  top: -10px;\n  background: #082026;\n  padding: 0 6px;\n  left: 9px;\n  font-weight: 200;\n}\n\n.field {\n  position: relative;\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.field label::before {\n  content: attr(title);\n  position: absolute;\n  top: 20px;\n  left: 15px;\n  line-height: 20px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #626262;\n  transition: 300ms all;\n  opacity: 0.5;\n}\n\n.field input,\n.field textarea {\n  line-height: 40px;\n  padding: 0 15px;\n  box-sizing: border-box;\n  font-size: 14px;\n  color: #1a1919;\n  border: 1px solid #f3f3f3;\n  border-radius: 9px;\n  margin: 0px;\n  font-weight: 500;\n  z-index: 22;\n  position: relative;\n}\n\n.field input:focus,\n.field textarea:focus {\n  outline: 0;\n}\n.field input:valid + label::before,\n.field textarea:valid + label::before {\n  content: attr(data-title);\n}\n\n.field label.top:before {\n  top: -12px;\n  background: #fff !important;\n  font-size: 16px;\n  color: #5e5e5e;\n}\n\n.field img {\n  position: absolute;\n  top: 14px;\n  right: 12px;\n  width: 34px;\n  z-index: 111;\n  cursor: pointer;\n}\n\n/* input#email:autofill~label {\n  top: -9px !important;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 17px;\n  color: var(--gray-700);\n  background: var(--gray-50);\n  padding: 0 8px;\n  z-index: 1;\n} */\n\n.profile-input-field {\n  margin-bottom: 34px;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.field input:disabled {\n  opacity: 0.5;\n}\n\n/********** Range slider css ****/\n\n/* .chart-wrap {\n  display: flex;\n  justify-content: center;\n} */\n\n.range-container {\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  height: 62px;\n  border: 1px solid #f3f3f3;\n  border-radius: 9px;\n  position: relative;\n  padding-top: 32px;\n}\n\n.range-container.dusting-slider {\n  padding-top: 10px;\n}\n\ninput[type=\"range\"] {\n  width: 400px;\n}\n\n.main-box {\n  height: 200px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n#steps {\n  margin-top: 50px;\n}\n\n.steps-counts {\n  display: flex;\n  justify-content: space-between;\n  width: 26%;\n}\n\n#stepsall {\n  border-radius: 8px;\n  height: 12px;\n  outline: none;\n  -webkit-appearance: none;\n  cursor: pointer;\n  /* width: 100%; */\n  width: 336px;\n}\n\ninput[type=\"range\"]::-webkit-slider-thumb {\n  width: 18px;\n  height: 18px;\n  -webkit-appearance: none;\n  background: #ffffff;\n  box-shadow: 0px 0px 4px #00000029;\n  border-radius: 50%;\n  padding: 0px;\n  margin: 0px;\n}\n\n.chart-and-image-wrap {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding-right: 10px;\n  padding-left: 10px;\n  width: 100px;\n  /* margin-right: 26px; */\n}\n\n.chart-and-image-left-wrap{\n  margin-right: 26px;\n}\n\n.sq-chart-and-img-wrap{\n  margin-right: 26px;\n}\n\n.chart-and-image-wrap img {\n  width: 33px;\n  margin-top: -24px;\n}\n\n.range-container.dusting-slider .chart-and-image-wrap img {\n  width: 34px;\n  margin-top: 0px;\n}\n\np#output {\n  width: 40px;\n  font-size: 14px;\n  color: #00a19b;\n  font-weight: 600;\n  margin: 0px;\n  text-align: left;\n  display: flex;\n  gap: 4px;\n}\n\np#output-reverse {\n  width: 40px;\n  font-size: 14px;\n  color: #1a1919;\n  font-weight: 600;\n  margin: 0px;\n  text-align: right;\n}\n\n.cleaning-name-wrap {\n  position: absolute;\n  top: 6px;\n  left: 60px;\n}\n\n.cleaning-name-wrap p,\n.cleaning-reverse-name-wrap p {\n  font-size: 14px;\n  color: #626262;\n  font-weight: 400;\n  margin: 0px;\n}\n\n.cleaning-reverse-name-wrap {\n  position: absolute;\n  top: 6px;\n  right: 60px;\n}\n\n.flooring-slider-wrap h5.flooring-text {\n  font-size: 14px;\n  color: #1a1919;\n  font-weight: 600;\n  margin: 0px;\n  padding-bottom: 5px;\n  padding-left: 10px;\n}\n\n.dusting-slider-wrap {\n  margin-top: 14px;\n}\n\n.dusting-slider-wrap h5.dusting-text {\n  font-size: 14px;\n  color: #1a1919;\n  font-weight: 600;\n  margin: 0px;\n  padding-bottom: 5px;\n  padding-left: 10px;\n}\n\ninput.error-msg {\n  border: 1px solid #ff0000 !important;\n}\n\n.error-msg.field label::before {\n  color: #ff0000 !important;\n  opacity: 1;\n}\n\nlabel.error-msg {\n  color: #ff0000 !important;\n}\n\n.disabled-button {\n  background: #f3f3f3;\n  opacity: 0.8;\n}\n\n.disabled-button:hover {\n  background: #f3f3f3;\n  opacity: 0.8;\n  color: #000000;\n}\n\n.date-and-time-wrapper input.error-msg::placeholder {\n  color: #ff0000 !important;\n}\n\n.error-msg.field label::before {\n  color: #ff0000 !important;\n  opacity: 1;\n}\n\n.extra-addto-cart-btn .disabled-button {\n  height: 49px;\n  opacity: 0.8;\n}\n\ninput.squirefeet-input {\n  text-align: right;\n  padding-right: 40px !important;\n}\n\n.squrefeet-slider-wrap{\n  margin-bottom: 16px;\n}\n\n.password-icon img:hover{\n  scale: 0.9;\n}\n\n\n\n/******* Resposive css ****/\n@media (max-width: 1024px) {\n  .simple-button {\n    height: 62px;\n    border-radius: 9px;\n    font-size: 14px;\n  }\n\n  .simple-button.gray-btn {\n    height: 62px;\n  }\n\n  .dusting-slider-wrap {\n    margin-top: 20px;\n  }\n\n  .sq-chart-and-img-wrap {\n    margin-right: 26px;\n  }\n\n  .chart-and-image-left-wrap {\n    margin-right: 26px;\n}\n\n.chart-and-image-left-wrap img{\n  display: none;\n}\n\n.chart-and-image-wrap {\n  width: unset;\n}\n\n#stepsall {\n  min-width: 280px;\n}\n\n}\n\n@media (max-width: 500px) {\n  #stepsall {\n    min-width: unset;\n    width: 280px;\n  }\n}\n\n@media (max-width: 360px) {\n  #stepsall {\n    width: 200px;\n  }\n}\n/* \n@media (min-width: 768px) and (max-width: 1024px) {\n  .field {\n    margin-bottom: 18px;\n }\n\n .login-option input {\n  height: 58px;\n  font-size: 14px;\n }\n\n.field input, .field textarea {\n  font-size: 14px;\n }\n\n .field label::before {\n   top: 18px;\n }\n\n.simple-button {\n  height: 58px;\n  font-size: 15px;\n }\n} */\n\n@media (min-width: 1025px) and (max-width: 1199px) {\n  .field {\n    margin-bottom: 18px;\n  }\n\n  .login-option input {\n    height: 58px;\n    font-size: 14px;\n  }\n\n  .field input,\n  .field textarea {\n    font-size: 14px;\n  }\n\n  .field label::before {\n    top: 18px;\n  }\n\n  .simple-button {\n    height: 58px;\n    font-size: 15px;\n  }\n\n  .field {\n    margin-bottom: 18px;\n  }\n\n  .login-option input {\n    /* height: 58px; */\n    height: 48px;\n    font-size: 12px;\n  }\n\n  .field input,\n  .field textarea {\n    font-size: 12px;\n  }\n\n  /* .field label::before {\n top: 18px;\n} */\n\n  .field label::before {\n    top: 14px;\n    font-size: 12px;\n  }\n\n  .simple-button {\n    height: 58px;\n    font-size: 15px;\n  }\n\n  .range-container {\n    height: 48px;\n  }\n\n  #stepsall {\n    height: 10px;\n  }\n\n  input[type=\"range\"]::-webkit-slider-thumb {\n    width: 14px;\n    height: 14px;\n  }\n\n  p#output {\n    font-size: 12px;\n  }\n\n  p#output-reverse {\n    font-size: 12px;\n  }\n\n  .chart-and-image-left-wrap {\n    margin-right: 0px;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1599px) {\n  .field {\n    margin-bottom: 18px;\n  }\n\n  .login-option input {\n    /* height: 58px; */\n    height: 48px;\n    font-size: 12px;\n  }\n\n  .field input,\n  .field textarea {\n    font-size: 12px;\n  }\n\n  /* .field label::before {\n     top: 18px;\n   } */\n\n  .field label::before {\n    top: 14px;\n    font-size: 12px;\n  }\n\n  .simple-button {\n    /* height: 58px; */\n    height: 48px;\n    font-size: 14px;\n  }\n\n  .range-container {\n    height: 48px;\n  }\n\n  #stepsall {\n    height: 10px;\n  }\n\n  input[type=\"range\"]::-webkit-slider-thumb {\n    width: 14px;\n    height: 14px;\n  }\n\n  p#output {\n    font-size: 12px;\n  }\n\n  p#output-reverse {\n    font-size: 12px;\n  }\n\n  .field img {\n    position: absolute;\n    top: 10px;\n    width: 28px;\n  }\n\n  .login-with-google-btn-wrap button img {\n    width: 24px;\n  }\n\n  .PhoneInputCountry {\n    font-size: 14px;\n  }\n\n  .PhoneInputCountry img {\n    width: 26px !important;\n  }\n\n  .field.phone-number-input input::placeholder {\n    font-size: 12px !important;\n    font-weight: 500;\n    color: #626262;\n    opacity: 0.5;\n  }\n\n  .squrefeet-slider-wrap{\n    margin-bottom: 6px;\n  }\n\n  #stepsall {\n    width: 220px;\n  }\n}\n\n@media (min-width: 1600px) and (max-width: 1700px) {\n    #stepsall {\n      width: 286px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
